import * as React from "react";
import { Storage } from "aws-amplify";
import styled, { css } from "styled-components";

import { s3GetObjectBodyToBase64 } from "src/library/utils";

export interface S3ImageProps {
  className?: string;
  placeholder?: string;
  s3Key: string | undefined;
  level: "public" | "protected" | "private";
  alt: string;
}

const S3Image: React.ReactFCWithChildren<S3ImageProps> = ({
  className, placeholder, s3Key, level, alt
}) => {
  const [ imgData, setImgData ] = React.useState<string | undefined>();
  const [ loadError, setLoadError ] = React.useState<boolean>(false);

  const fetchImage = async () => {
    setLoadError(false);

    // Only run if s3Key is valid
    if (s3Key && s3Key.length > 0) {
      // Attempt to get the requested image from S3 using Amplify Storage
      Storage.get(s3Key, { level })
        .then(data => {
          if (typeof data === "string") {
            return setImgData(data);
          }

          const typedResult: any = data;
          const base64Data = s3GetObjectBodyToBase64(typedResult.Body, typedResult.ContentType);

          setImgData(base64Data);
        })
        .catch(error => {
          console.log(error);
          setLoadError(true);
        });
    }
  };

  // Load the requested image (on mount and on key change)
  React.useEffect(() => {
    fetchImage();
  }, [ s3Key ]);

  return (
    <Image
      className={[ className, !imgData && placeholder ? "placeholder" : "" ].join(" ")}
      src={imgData || placeholder || "/assets/mezze-small-white.svg"}
      hidden={!!s3Key && !imgData && !loadError}
      alt={alt}
    />
  );
};

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    background-color: ${theme.colors.white};
    padding-bottom: 100%;

    img {
      height: auto;
      width: auto;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      max-width: 100%;
      max-height: 100%;
      position: absolute;
    }
    &.placeholder img {
      width: 30px;
    }
  `}
`;

const Image = styled.img`
  display: block;
  width: 100%;

  &.placeholder {
    position: absolute;
    top: 50%;
    width: 30px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export default S3Image;
